"use client";
import Link from "next/link";
import { ArrowRight, FileText } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { contactForm as data } from "@/lib/data/contact";

const accent = "var(--color-crimson)";

export function ContactForm() {
  return (
    <Section id="contact-form" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-crimson)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-10 grid lg:grid-cols-2 gap-5">
          <Reveal delay={100}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <span className="grid place-items-center h-10 w-10 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                  <FileText className="h-4 w-4" style={{ color: accent }} />
                </span>
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Inquiry Categories</span>
              </div>
              <div className="mt-4 space-y-3">
                {data.categories.map((c, i) => (
                  <div key={c.name} className="text-sm">
                    <div className="font-semibold" style={{ color: accent }}>{c.name}</div>
                    <div className="text-[rgb(var(--fg-muted))] mt-0.5 leading-relaxed">{c.body}</div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Required Information</span>
              <ul className="mt-4 space-y-2">
                {data.required.map((r, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">
                    <span className="h-1.5 w-1.5 rounded-full mt-2 shrink-0" style={{ background: accent }} />
                    {r}
                  </li>
                ))}
              </ul>
              <div className="mt-6">
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>What Happens After Submission</span>
                <div className="mt-4 space-y-3">
                  {data.process.map((p, i) => (
                    <p key={i} className="text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{p}</p>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        </div>
        <Reveal delay={300}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
